import React from "react";
import { formatBook } from "../../../utils/formatOdds";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

// Reference label text nodes carry the template's whitespace ("\n   ODD\n   ")
const txt = (label) => `\n                      ${label}\n                    `;

// Questions in reference order; each option = odds `nat` + what the reference label shows (text or suit images)
const Q_TOP = [
  { subtype: "redblack", title: "Red-Black", options: [
    { nat: "Red", imgs: ["heart", "diamond"] },
    { nat: "Black", imgs: ["spade", "club"] },
  ] },
  { subtype: "oddeven", title: "Odd-Even", options: [
    { nat: "Odd", text: "ODD" },
    { nat: "Even", text: "EVEN" },
  ] },
  { subtype: "updown", title: "7 Up-7 Down", options: [
    { nat: "Up", text: "UP" },
    { nat: "Down", text: "DOWN" },
  ] },
];
const Q_OTHERS = [
  { subtype: "cardj", title: "3 Card Judgement", options: [
    { nat: "A23", text: "1 2 3" },
    { nat: "456", text: "4 5 6" },
    { nat: "8910", text: "8 9 10" },
    { nat: "JQK", text: "J Q K" },
  ] },
  { subtype: "color", title: "Suits", options: [
    { nat: "Spade", imgs: ["spade"] },
    { nat: "Heart", imgs: ["heart"] },
    { nat: "Club", imgs: ["club"] },
    { nat: "Diamond", imgs: ["diamond"] },
  ] },
];

/**
 * K.B.C bet area in the reference admin markup (styled by the ported `.kbc .kbc-btns` rules in index.css):
 *   .row.row5.kbc-btns > .col-12.col-md-4 x3 (Q1-Q3) and .row.row5.kbc-btns.kbcothers.mt-2 > .col-12.col-md-6 x2 (Q4-Q5)
 *   each: .casino-box-row > .casino-nation-name > b "[Qn] {nat}" + .btn-group.btn-group-toggle > label.btn[.suspended]
 * The admin reference shows no odds; a label is `suspended` while its question's gstatus is not OPEN.
 */
const BetTableKBC = ({ data = [], onBetClick, exposures = {} }) => {
  const getSection = (subtype) =>
    data.find((item) => String(item?.subtype || "").toLowerCase() === subtype);

  const renderQuestion = (q, qIndex, colClass) => {
    const section = getSection(q.subtype);
    const suspended = String(section?.gstatus || "").toUpperCase() !== "OPEN";
    const odds = section?.odds || [];

    return (
      <div className={colClass} key={q.subtype}>
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b>{`[Q${qIndex}] ${section?.nat || q.title}`}</b>
          </div>{" "}
          <div data-toggle="buttons" className="btn-group btn-group-toggle">
            {q.options.map((opt, i) => {
              const odd = odds.find((o) => String(o?.nat || "").toLowerCase() === opt.nat.toLowerCase()) || { nat: opt.nat, b: 0 };
              const selectionName = `${section?.nat || q.subtype} ${odd.nat}`;
              const exposure = exposures[selectionName] ?? exposures[odd.nat] ?? 0;
              const handleClick = () => {
                if (suspended || !section || typeof onBetClick !== "function") return;
                onBetClick(`${q.subtype}_${odd.nat}`, opt.text || opt.nat, "back", {
                  nat: selectionName,
                  sid: section.sid,
                  ssid: odd.ssid,
                  sno: odd.sno,
                  subtype: section.subtype,
                  gtype: section.gtype,
                  etype: section.etype,
                });
              };
              return (
                <React.Fragment key={opt.nat}>
                  {i > 0 && " "}
                  <label className={`btn${suspended ? " suspended" : ""}`} onClick={handleClick}>
                    <input
                      type="radio"
                      name="options"
                      id={i === 0 ? "option1" : "option2"}
                      autoComplete="off"
                      defaultChecked={i === 0}
                    />
                    {opt.imgs
                      ? opt.imgs.map((img) => (
                          <React.Fragment key={img}>
                            {" "}
                            <img src={`${IMG}/${img}.png`} alt="" />
                          </React.Fragment>
                        ))
                      : txt(opt.text)}
                    {exposure !== 0 && (
                      <span className={exposure < 0 ? "text-danger" : "text-success"}>
                        {" "}{formatBook(exposure)}
                      </span>
                    )}
                  </label>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="row row5 kbc-btns">
        {Q_TOP.map((q, i) => (
          <React.Fragment key={q.subtype}>
            {i > 0 && " "}
            {renderQuestion(q, i + 1, "col-12 col-md-4")}
          </React.Fragment>
        ))}
      </div>{" "}
      <div className="row row5 kbc-btns kbcothers mt-2">
        {Q_OTHERS.map((q, i) => (
          <React.Fragment key={q.subtype}>
            {i > 0 && " "}
            {renderQuestion(q, i + 4, "col-12 col-md-6")}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default BetTableKBC;
